import { render } from "./JobsMonitor.vue?vue&type=template&id=48b45bc6&scoped=true&ts=true"
import script from "./JobsMonitor.vue?vue&type=script&lang=ts"
export * from "./JobsMonitor.vue?vue&type=script&lang=ts"

import "./JobsMonitor.vue?vue&type=style&index=0&id=48b45bc6&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\keisi\\keisishopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b45bc6"]])

export default __exports__